import "./MiniGallery.css";
import "./MiniGalleryResponsive.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import CustomAnchor from "../../../shared/Anchor/CustomAnchor";
import RenderImages from "../../render-images/RenderImages";

function MiniGallery() {
  return (
    <div className="mini-gallery">
      <div className="m-0 mini-gallery-header">
        <h1>
          <span>Our Gallery Experience</span>
          <div id="galley-experience-bottom-boarder"></div>
        </h1>
      </div>
      <div className="row m-0 mini-gallery-slide">
        <RenderImages classname="col-lg-2 col-md-3 col-sm-4 col-10 mini-gallery-slide-show" />
      </div>
      <div className="mini-gallery-footer">
        <CustomAnchor
          path="/about/gallery"
          classname="btn btn-dark btn-md mini-more-gallery-images"
        >
          <span>See More</span>
          <FontAwesomeIcon
            icon={faArrowUpRightFromSquare}
            className="header-anchor-icon"
          />
        </CustomAnchor>
      </div>
    </div>
  );
}

export default MiniGallery;
